import type { Task } from "@common/types/task";
import { TasksBulkActionsFooter } from "./TasksBulkActionsFooter";
import { TasksBulkDeleteModal } from "./TasksBulkDeleteModal";
import { useOrganizationTaskBulkActions } from "./useOrganizationTaskBulkActions";
import { useTaskBulkActions } from "./useTaskBulkActions";

interface TasksListBulkActionsProps {
    show: boolean;
    selectedTaskIds: string[];
    selectedTasks: Task[];
    clearSelection: () => void;
}

interface OrganizationTasksListBulkActionsProps extends TasksListBulkActionsProps {
    setSelectedTaskIds: (taskIds: string[]) => void;
}

export const WorkspaceTasksListBulkActions = ({
    show,
    selectedTaskIds,
    selectedTasks,
    clearSelection,
}: Readonly<TasksListBulkActionsProps>) => {
    const {
        showDeleteConfirm,
        setShowDeleteConfirm,
        handleSetStatusClick,
        handleAssignMemberClick,
        handleBulkDeleteConfirm,
        handleOpenBulkActions,
    } = useTaskBulkActions({ selectedTaskIds, selectedTasks, clearSelection });

    return (
        <>
            <TasksBulkActionsFooter
                show={show}
                onDeselectRows={clearSelection}
                onSetStatus={handleSetStatusClick}
                onAssignMember={handleAssignMemberClick}
                onOpenBulkActions={handleOpenBulkActions}
                selectedCount={selectedTaskIds.length}
                selectedTasks={selectedTasks}
            />
            <TasksBulkDeleteModal
                show={showDeleteConfirm}
                selectedCount={selectedTaskIds.length}
                onConfirm={handleBulkDeleteConfirm}
                onClose={() => setShowDeleteConfirm(false)}
            />
        </>
    );
};

export const OrganizationTasksListBulkActions = ({
    show,
    selectedTaskIds,
    selectedTasks,
    clearSelection,
    setSelectedTaskIds,
}: Readonly<OrganizationTasksListBulkActionsProps>) => {
    const { handleSetStatusClick, handleOpenBulkActions } =
        useOrganizationTaskBulkActions({ selectedTasks, setSelectedTaskIds });

    return (
        <TasksBulkActionsFooter
            show={show}
            onDeselectRows={clearSelection}
            onSetStatus={handleSetStatusClick}
            onOpenBulkActions={handleOpenBulkActions}
            selectedCount={selectedTaskIds.length}
            selectedTasks={selectedTasks}
        />
    );
};
